var map = {
	"./404.vue": [
		"8cdb",
		"chunk-0a4b895f"
	],
	"./Dataset.vue": [
		"a564",
		"chunk-b59c5062",
		"chunk-191c475d",
		"chunk-70b9c859"
	],
	"./Login.vue": [
		"a55b",
		"chunk-12159bb7"
	],
	"./PDF.vue": [
		"e4a5",
		"chunk-b59c5062",
		"chunk-191c475d",
		"chunk-b9d14a8e"
	],
	"./Register.vue": [
		"73cf",
		"chunk-799655a7"
	],
	"./Search.vue": [
		"2d3b",
		"chunk-b59c5062",
		"chunk-ea9efa4c"
	],
	"./Settings.vue": [
		"26d3",
		"chunk-ed691742"
	],
	"./settings/Details.vue": [
		"1b1d",
		"chunk-6f29a2d0"
	],
	"./settings/Notifications.vue": [
		"76ad",
		"chunk-4664358f"
	],
	"./settings/Personalization.vue": [
		"5ba8",
		"chunk-d603fb7c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;